<div class="breadcrumb header-clients-360">
	<div class="row">
		<div class="col d-flex align-items-center">
			<a [routerLink]="['/admin']" translate>menu.home</a>
			<i class="material-icons">keyboard_arrow_right</i>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<h1 class="mt-2" translate>client.clients</h1>
		</div>
		<div class="col col-auto">
			<a [routerLink]="['/admin/personalization']" class="btn btn-primary btn-rounded d-flex align-items-center">
				<i class="fal fa-plus mr-2"></i>
				{{ 'client.addClient' | translate }}
			</a>
		</div>
	</div>

	<div class="row">
		<h4 class="col mt-2" translate [translateParams]="{ count: pageControl.count }">client.numClientsRegistered</h4>
	</div>
</div>

<div class="row header-row-360">
	<div *ngIf="initialLoad || searching; else hasItems" class="d-flex justify-content-center align-items-center p-5">
		<mat-spinner></mat-spinner>
	</div>
	<ng-template #hasItems>
		<div class="col-md-12">
			<div class="card d-none d-lg-block">
				<div class="card-body container-card-body-list">
					<div class="filter-container">
						<div class="col"></div>
						<div class="col-auto">
							<form class="filter-container__search" (ngSubmit)="onSearch()" [formGroup]="formSearch">
								<input
									type="text"
									placeholder="{{ 'client.search.placeholder' | translate }}"
									formControlName="search"
								/>
								<button type="submit">
									<i class="fa fa-search"></i>
								</button>
							</form>
						</div>
					</div>
					<div class="table-responsive">
						<table class="table table-hover">
							<thead>
								<tr>
									<ng-container *ngFor="let column of columns">
										<th [style.text-align]="column.align || 'left'">
											{{ column.header | translate }}
										</th>
									</ng-container>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let client of list">
									<tr>
										<td [routerLink]="['/admin/personalization/', client.id]" style="cursor: pointer">
											<div class="d-flex">
												<div class="logo-company" *ngIf="client.logoUrl">
													<div
														[ngStyle]="{ 'background-image': 'url(\'' + client.logoUrl + '\')' }"
														class="logo-company-image"
													></div>
												</div>
												<div
													class="logo-company d-flex justify-content-center align-items-center"
													*ngIf="!client.logoUrl"
												>
													<span class="d-flex align-items-center flex-column text-uppercase">
														<i class="fal fa-image"></i>
														{{ 'noImage' | translate }}
													</span>
												</div>
												<div class="content-name-type">
													<h4>{{ client.name }}</h4>
													<h5 class="text-uppercase">{{ 'client.type' + client.type | translate }}</h5>
												</div>
											</div>
										</td>
										<td>
											<div class="table-cell-link">
												<a target="_blank" [href]="handleUrl(client.permalink)">{{ handleUrl(client.permalink) }}</a>
											</div>
										</td>
										<td>
											<div class="table-cell-link">
												<a target="_blank" [href]="client.domain">{{ client.domain }}</a>
											</div>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
					<btn-load-more [hasMore]="pageControl.hasMore" (loadMore)="loadMore()" [loading]="loading"></btn-load-more>
				</div>
			</div>

			<div class="d-lg-none container-card-body-list--mobile">
				<div class="filter-container">
					<div class="col-auto">
						<form class="filter-container__search" (ngSubmit)="onSearch()" [formGroup]="formSearch">
							<input type="text" placeholder="{{ 'client.search.placeholder' | translate }}" formControlName="search" />
							<button type="submit">
								<i class="fa fa-search"></i>
							</button>
						</form>
					</div>
				</div>

				<ng-container *ngFor="let client of list">
					<div class="card mb-2">
						<div class="card-body">
							<div
								class="d-flex logo-container-mobile"
								[routerLink]="['/admin/personalization/', client.id]"
								style="cursor: pointer"
							>
								<div class="logo-company" *ngIf="client.logoUrl">
									<div
										[ngStyle]="{ 'background-image': 'url(\'' + client.logoUrl + '\')' }"
										class="logo-company-image"
									></div>
								</div>
								<div class="logo-company d-flex justify-content-center align-items-center" *ngIf="!client.logoUrl">
									<span class="d-flex align-items-center flex-column text-uppercase">
										<i class="fal fa-image"></i>
										{{ 'noImage' | translate }}
									</span>
								</div>
								<div class="content-name-type">
									<h4>{{ client.name }}</h4>
									<h5 class="text-uppercase">{{ 'client.type' + client.type | translate }}</h5>
								</div>
							</div>

							<div class="content-mobile">
								<i class="fa fa-link"></i>
								<a target="_blank" [href]="handleUrl(client.permalink)">{{ handleUrl(client.permalink) }}</a>
								<i class="fa fa-copy" (click)="copyLink(handleUrl(client.permalink))"></i>
							</div>
							<div class="content-mobile" *ngIf="client.domain">
								<i class="fa fa-link"></i>
								<a target="_blank" [href]="client.domain">{{ client.domain }}</a>
								<i class="fa fa-copy" (click)="copyLink(client.domain)"></i>
							</div>
						</div>
					</div>
				</ng-container>

				<btn-load-more
					class="mt-4"
					[hasMore]="pageControl.hasMore"
					(loadMore)="loadMore()"
					[loading]="loading"
				></btn-load-more>
			</div>
		</div>
	</ng-template>
</div>

<div *ngIf="!loading && searchTerm && list?.length === 0" class="w-100 text-center mt-4 text-muted">
	{{ 'client.search.noResults' | translate : { term: searchTerm } }}
</div>
